import CHECKLISTS from './CHECKLISTS'
import Checklist from '@/classes/Checklist'

export default {
  CHECKLISTS: CHECKLISTS as {[key: string]: Checklist}
}
